import * as stylex from "@stylexjs/stylex";
import "../tokens.stylex.ts";
import { color, fontSize, media, motion, radius, space } from "../tokens.stylex.ts";
import { surface } from "./surface.styles.ts";

/**
 * True while a popup is mounting or unmounting. Base UI reports `undefined`
 * (not only `"idle"`) once the transition has settled, so check both ends.
 */
export function isTransitioning(status: string | undefined): boolean {
  return status === "starting" || status === "ending";
}

/** Raised, untextured popup: spread before `popupStyles.surface`. */
export const popupSurface = [surface.raised, surface.sm, surface.plain] as const;
export const popupStyles = {
  surface: {
    kaIpWk: "xlfxrz8",
    kI3sdo: "x1a2a7pz",
    k1ekBW: "x6o7n8i",
    kIyJzY: "x7updtu",
    kAMwcw: "xyda15a",
    $$css: true
  },
  entering: {
    kSiTet: "xg01cxk",
    k3aq6I: "x1m3itv7",
    $$css: true
  },
  menuItem: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1a62zme",
    k8WAf4: "x1t0vds8 xu4g0nv",
    kg3NbH: "x1uu5im9 x1g5qazo",
    kaIpWk: "x1y8ptio",
    kGuDYH: "xluwven xcb8g08",
    kMwMTN: "x9aqtqa",
    kkrTdU: "x1ypdohk",
    kI3sdo: "x1a2a7pz",
    kfSwDN: "x87ps6o",
    kybGjl: "x1hl2dhg",
    $$css: true
  },
  menuItemHighlighted: {
    kWkggS: "x2aygxa",
    $$css: true
  },
  menuItemDanger: {
    kMwMTN: "x1xcodwn",
    $$css: true
  }
};